<template>
  <div id="gantt-chart" class="gantt-chart">
    <div class="gantt-header">
      <div class="gantt-header-label">{{p_tableName}}</div>
		<div class="gantt-header-timeline">
			<div  v-for="(month, index) in c_months"   :key="index"  class="gantt-header-cell">
				{{ month.label }}
			</div>
		</div>
    </div>

    <div class="gantt-body">
      <div
        v-for="item in c_ganttData"
        :key="item.label"
        class="gantt-row"
      >
        <div class="gantt-row-label" :title="item.label">
          {{ item.label }}
        </div>
        <div class="gantt-row-timeline">
          <div
            class="gantt-bar"
			:title="item.title"
            :style="m_getBarStyle(item)"
          ></div>
        </div>
      </div>
    </div>
	<div v-show="c_noData" id="no-data">No Data</div>
  </div>
</template>

<script>
const DAY = 1000 * 60 * 60 * 24
const DAY_WIDTH = 40
const MONTH_WIDTH = 80
import {fn_appEnt} from "@/utils/ref-data.js";
//import moment from "moment";
export default {
  name: "GanttChart",
  props: {
    p_startDate:Date,
	p_endDate:Date,
	p_constructionDates:{type: Array,
			default: () => []
    },
	p_opportunities:Boolean,
	p_projects:Boolean,
  },
  data() {
		return {
		d_appEnt:null,
		d_constructionDates:[],
		}
   },
  created() { 
			console.log('In ganttChart created');
			console.log(this.p_constructionDates);
			this.d_appEnt=fn_appEnt(this.p_appEntKey);
  
  },
  computed: {
  
c_ganttData() {

	console.log('In c_ganttData');
	console.log(this.p_constructionDates);

  const startFilter = this.p_startDate;  // Vue reactive
  const endFilter   = this.p_endDate;    // Vue reactive

  const filterStart = startFilter ? new Date(startFilter) : null;
  const filterEnd   = endFilter   ? new Date(endFilter)   : null;

  const globalStart = this.d_startDate;
  const globalEnd   = this.d_endDate;
  
    const ganttData = this.p_constructionDates
    .map(row => {
      const { recordName: label, startDate, endDate, recordType } = row;

	if (!label || !startDate || !endDate) return null;
	const isOppr = row.recordType=='opportunity';
	const isProj = row.recordType=='project';

	if((isOppr&&!this.p_opportunities)||(isProj&&!this.p_projects)) return null;

      const dStart = new Date(startDate);
      const dEnd   = new Date(endDate);


	

      // --- Clamp to global visible window ---
      const cStart = globalStart?Math.max(dStart, globalStart):dStart;
      const cEnd   = globalEnd?Math.min(dEnd, globalEnd):dEnd;

      return {
        label,
        title: `${dStart.toLocaleString()} - ${dEnd.toLocaleString()}`,
        start: dStart,
        end: cEnd,
        recordType
      };
    })
    .filter(Boolean);
	
	console.log('In c_ganttData');
	console.log(ganttData);

  return ganttData;
},
c_noData(){return this.p_constructionDates.length==0;},
c_minDate() {
	
 var minDate= new Date(
	Math.min(
    ...this.p_constructionDates
      .map(i => new Date(i.startDate))
      .filter(d => d instanceof Date && !isNaN(d))
      .map(d => d.getTime())
  ));
  
  console.log(`In c_startDate ${this.p_startDate}`);
  return new Date(this.p_startDate);

 },
c_maxDate() {
		//return  new Date(Math.max(...this.p_constrctionDates.map(i => i.endDate?.getTime())));
	var maxDate = new Date(
	Math.max(
    ...this.p_constructionDates
      .map(i => new Date(i.endDate))
      .filter(d => d instanceof Date && !isNaN(d))
      .map(d => d.getTime())
  ));
  console.log(`In c_endDate ${this.p_endDate}`);
  return new Date(this.p_endDate);
},
//c_startDate() {return this.d_startDate?moment(this.d_startDate).format('YYYY-MM-DD'):null;},
//c_endDate() {return this.d_endDate?moment(this.d_endDate).format('YYYY-MM-DD'):null;},	
c_months() {
  const months = [];
  const toFirstOfMonth = d => new Date(d.getFullYear(), d.getMonth(), 1);
  const toLastOfMonth = d => new Date(d.getFullYear(), d.getMonth() + 1, 0);


  
  //var minDate = new Date(Math.min(...this.p_constructionDates.map(i => i.startDate.getTime())))
  //var maxDate =new Date(Math.max(...this.p_constructionDates.map(i => i.endDate.getTime())));
  
  const timestamps = (this.p_constructionDates || [])
  .flatMap(i => [i.startDate, i.endDate])
  .map(d => new Date(d))
  .filter(d => d instanceof Date && !isNaN(d))
  .map(d => d.getTime());


    
	
	//const minDate = new Date(Math.min(...timestamps));
	//const maxDate = new Date(Math.max(...timestamps));
	
	//const minDate = new Date(this.p_startDate);
	const minDate = new Date(toFirstOfMonth(new Date(this.p_startDate)));
	//const maxDate = new Date(this.p_endDate);
	const maxDate = new Date(toLastOfMonth(new Date(this.p_endDate)));
	
	
  
	const current = new Date( minDate.getFullYear(), minDate.getMonth(), 1);

  while (current <= maxDate) {
    months.push({
      date: new Date(current), // ← clone the date
      label: current.toLocaleString("default", { month: "short", year: "numeric" }).replace(" ", "-")
    });
    current.setMonth(current.getMonth() + 1);
  }

  console.log("In c_months");
  console.log(`In c_months ${minDate} ${this.p_minDate}`);
  console.log(months);
  return months;
	}
},

  methods: {
    m_msToPx(ms) {
      return (ms / this.c_totalMs) * this.p_width;
    },

    m_getBarStyle1(item) {
      const startOffset = item.start.getTime() - this.c_minDate.getTime();
      const duration = item.end.getTime() - item.start.getTime();

      return {
		
		color: item.recordType=='opportunity'?"#ff8000":"yellow",
		background:item.recordType=='opportunity'?"#9dc254":"#4076ba", 
        left: this.m_msToPx(startOffset) + "px",
        width: this.m_msToPx(duration) + "px"
		
      };
    },
    m_getMonthDiff(date1, date2) {
      return (
        (date1.getFullYear() - date2.getFullYear()) * 12 +
        (date1.getMonth() - date2.getMonth())
      )
	  //return Math.ceil(moment(endDate).diff(startDate, 'months', true));
    },
    m_getBarStyle(item) {
		console.log('In m_getBarStyle');
		console.log(this.c_months);
		
		const toFirstOfMonth = d => new Date(d.getFullYear(), d.getMonth(), 1);
		const minDate=toFirstOfMonth(new Date(this.p_startDate));
		const toLastOfMonth = d => new Date(d.getFullYear(), d.getMonth() + 1, 0);
		const maxDate=toLastOfMonth(new Date(this.p_endDate));


		
		console.log(`In  start ${item.start} ${this.c_minDate} end ${item.end} ${this.c_maxDate}`);
		var start = new Date(Math.max(item.start,this.c_minDate));
		var end = new Date(Math.min(item.end,maxDate));
		
		//const offset = this.m_getMonthDiff(start, this.c_minDate) + 1;
		//const duration = this.m_getMonthDiff(end, start) + 1
			
		
		
		//const offset =  fn_getMonthDiffPrecise(start, this.c_minDate)+1;
		
		const offset =  fn_getMonthDiffPrecise(start, minDate);
		const duration = fn_getMonthDiffPrecise(end, start);
		
		
		console.log(`In  start ${item.title} ${item.start} end ${item.end}`);
		console.log(`left ${offset * MONTH_WIDTH}px width ${duration * MONTH_WIDTH}px`);
		
      return {
		color: item.recordType=='opportunity'?"#ff8000":"yellow",
		background:item.recordType=='opportunity'?"#9dc254":"#4076ba",
        left: `${offset * MONTH_WIDTH}px`,
        width: `${duration * MONTH_WIDTH}px`
      }
    },

  },
 watch:{}
		
}
function daysInMonth(d) {
  // d is a Date
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
}

function monthIndexFractional(d) {
  const year = d.getFullYear();
  const month = d.getMonth(); // 0-11

  const dim = daysInMonth(d);

  // Include time-of-day so bars within the same day don't "jump"
  const secondsInDay =
    d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() + d.getMilliseconds() / 1000;

  const timeFrac = secondsInDay / 86400;

  // day-1 makes the 1st of the month align exactly with the month boundary
  const frac = ((d.getDate() - 1) + timeFrac) / dim;

  return (year * 12 + month) + frac;
}

/**
 * Continuous month difference (fractional)
 * Positive if a is after b.
 */
function fn_getMonthDiffPrecise(a, b) {
  return monthIndexFractional(a) - monthIndexFractional(b);
}
</script>

<style scoped>
.gantt-chart {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.gantt-header {
  display: flex;
  background: #f7f7f7;
  border-bottom: 1px solid #ddd;
}

.gantt-header-label {
  flex-shrink: 0;
  width: 160px;
  padding: 8px;
  font-weight: 600;
  border-right: 1px solid #ddd;
}

.gantt-header-timeline {
  flex: 1;
  display: flex;
}

.gantt-header-tick {
  flex: 1;
  text-align: center;
  padding: 4px 0;
  border-left: 1px solid #eee;
  color: #666;
}

.gantt-body {
  max-height: 400px;
  overflow-y: auto;
}

.gantt-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
}

.gantt-row-label {
  width: 160px;
  padding: 6px 8px;
  border-right: 1px solid #f0f0f0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.gantt-row-timeline {
  flex: 1;
  position: relative;
  height: 28px;
}

.gantt-bar {
  position: absolute;
  top: 6px;
  height: 16px;
  border-radius: 8px;
  background1: linear-gradient(90deg, #4f46e5, #22c55e);
}
.gantt-header-cell {
  width: 80px;    
  font-size: 12px;
  text-align: center;
  border-right: 1px solid #eee;
  font-weight:bold;
}
</style>
